import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import Products from 'merchandise-lib/constants/Product';
import { CustomerPlatformFAQs } from 'pricing-pages-ui-components/frequentlyAskedQuestions/CustomerPlatformFAQs';
import { PageSubTitle, PageTitle } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import { CreditsCallout } from '../../../components/common/credits-callout/CreditsCallout';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import CalculatorAnchorLink from '../../components/CalculatorAnchorLink';
import PhoneSupportFooter from '../../components/phone-support/PhoneSupportFooter';
import { BannerSection } from '../../containers/BannerSection';
import { FeatureTableContainer } from '../../containers/FeatureTableContainer';
import { IntegrationsSection } from '../../containers/IntegrationsSection';
import { trackClickedLink, trackFaqInteraction, trackPageView } from '../../utils/tracking/trackingEventUtils';
import { TRACKING_SOURCES } from '../../constants/tracking/TrackingSources';
import { CustomerPlatformMerchCards } from './CustomerPlatformMerchCards';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CRM_SUITE_API_NAMES = [Products.CRM_SUITE_STARTER_BUNDLE, Products.CRM_SUITE_PROFESSIONAL_BUNDLE, Products.CRM_SUITE_ENTERPRISE_BUNDLE];
export const CustomerPlatformPage = () => {
  useDocumentTitle('crmSuite');
  useEffect(() => {
    trackPageView({
      screen: 'suite'
    });
  }, []);
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "CUSTOMER_PLATFORM_PAGE_V2",
    children: [/*#__PURE__*/_jsx(BannerSection, {
      screen: "SUITE",
      apiNames: CRM_SUITE_API_NAMES
    }), /*#__PURE__*/_jsxs(View, {
      textAlign: "center",
      marginBlockEnd: "800",
      children: [/*#__PURE__*/_jsx(PageTitle, {
        "aria-level": 1,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.customerPlatform.pageTitle"
        })
      }), /*#__PURE__*/_jsxs(PageSubTitle, {
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "pricing-pages-ui.pagesV2.customerPlatform.description"
        }), /*#__PURE__*/_jsx(CalculatorAnchorLink, {
          defaultProductApiName: Products.CRM_SUITE_PROFESSIONAL_BUNDLE
        })]
      })]
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CustomerPlatformMerchCards, {})
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CreditsCallout, {
        navItem: "suite"
      })
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(FeatureTableContainer, {
        skuCategoryName: "CRM_SUITE",
        productApiNames: CRM_SUITE_API_NAMES,
        screen: "pricing-page-crm-suite"
      })
    }), /*#__PURE__*/_jsx(IntegrationsSection, {
      nav: "suite"
    }), /*#__PURE__*/_jsx(PageSection, {
      children: /*#__PURE__*/_jsx(CustomerPlatformFAQs, {
        onLinkClick: props => trackClickedLink(Object.assign({}, props, {
          trackingSource: TRACKING_SOURCES.FAQ
        })),
        onFaqInteraction: trackFaqInteraction
      })
    }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
      phoneSourceId: "crmsuite-footer",
      screen: "suite",
      apiName: Products.CRM_SUITE_STARTER_BUNDLE
    })]
  });
};